/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Push",
  size: 20
}

const SvgPush = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M12.15 4L9.5 1.4 6.85 4l-.7-.7L9.5 0l3.35 3.3z" />
    <path fill="none" d="M9.5 10V1M6 5.5H3.5v13h12v-13H13" />
  </Svg>
)

SvgPush.defaultProps = defaultProps
export default SvgPush
